"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    labelKeys: function() {
        return labelKeys;
    },
    getAttributes: function() {
        return getAttributes;
    },
    getTitle: function() {
        return getTitle;
    },
    getLegend: function() {
        return getLegend;
    },
    titleFormatter: function() {
        return titleFormatter;
    },
    legendFormatter: function() {
        return legendFormatter;
    },
    getLegendKeysTitle: function() {
        return getLegendKeysTitle;
    },
    isSingleTrace: function() {
        return isSingleTrace;
    },
    findTraceByLabel: function() {
        return findTraceByLabel;
    },
    findTracesForParam: function() {
        return findTracesForParam;
    }
});
require("@google-web-components/google-chart");
const _paramtools = require("../paramtools");
const _testpicker = require("../common/test-picker");
const labelKeys = [
    'master',
    'bot',
    'benchmark',
    'improvement_direction',
    'stat',
    'unit',
    'test',
    'subtest_1',
    'subtest_2',
    'subtest_3',
    'subtest_4',
    'subtest_5',
    'subtest_6'
];
const getAttributes = (df)=>{
    const traceKeys = Object.keys(df.traceset);
    const pairs = convertKeysToPairs(traceKeys);
    const attributes = pairs.map((p)=>p.split('=')[0]);
    return Array.from(new Set(attributes));
};
const getTitle = (dt)=>{
    const numCols = dt.getNumberOfColumns();
    const traceKeys = [];
    // skip the first two columns since they are domains
    for(let i = 2; i < numCols; i++){
        traceKeys.push(dt.getColumnLabel(i));
    }
    const pairs = convertKeysToPairs(traceKeys);
    // filters key-value pairs that appear across all keys
    // assumes that key-value pairs cannot appear more than once
    // within the same traceKey
    const commonPairs = pairs.filter((pair, _, arr)=>{
        const count = arr.filter((x)=>x === pair).length;
        return count === traceKeys.length;
    });
    return Object.fromEntries([
        ...new Set(commonPairs)
    ].map((value)=>{
        return value.split('=');
    }));
};
const getLegend = (dt)=>{
    const numCols = dt.getNumberOfColumns();
    const traceKeys = [];
    // skip the first two columns since they are domains
    for(let i = 2; i < numCols; i++){
        const k = dt.getColumnLabel(i);
        const formattedKey = (0, _paramtools.formatSpecialFunctions)(k);
        // There are special traces with no data, only "special_zero" as the trace name.
        // They do not show any data on the graph, so we remove them.
        if (formattedKey !== 'special_zero') {
            traceKeys.push(formattedKey);
        }
    }
    const pairs = convertKeysToPairs(traceKeys);
    const uniqKVP = [];
    // for each key, split the traceKey into key-value pairs
    // and filter for entries that do not appear across all traceKeys
    if (traceKeys.length >= 1) {
        for (const key of traceKeys){
            const kvp = key.split(',').filter((pair)=>pair.length);
            const uniq = kvp.filter((item)=>pairs.filter((x)=>x === item).length < traceKeys.length);
            uniqKVP.push(Object.fromEntries(uniq.map((item)=>{
                return item.split('=');
            })));
        }
    }
    // Get all unique keys from the objects in the array
    const allKeys = new Set(uniqKVP.flatMap(Object.keys));
    // Fill in missing or blank keys in the map with empty string
    const legend = uniqKVP.map((obj)=>{
        const newObj = {};
        Array.from(allKeys).sort() // Sort the keys alphabetically
        .forEach((key)=>{
            newObj[key] = obj[key] ? obj[key] : _testpicker.DEFAULT_OPTION_LABEL;
        });
        return newObj;
    });
    return legend;
};
/**
 * converts traceKeys to a list of individual key-value pairs and
 * removing any trailing spaces and commas. If any of the trace keys
 * are special function keys like norm(,a=A,b=B,c=C,), extract out
 * the actual key ,a=A,b=B,c=C, from the trace name.
 */ function convertKeysToPairs(traceKeys) {
    return traceKeys.map((key)=>{
        const formattedKey = (0, _paramtools.formatSpecialFunctions)(key);
        return formattedKey.split(',').filter((pair)=>pair.length);
    }).flat();
}
function titleFormatter(title) {
    return Object.values(title).join('/');
}
function legendFormatter(legend) {
    return legend.map((entry)=>Object.values(entry).filter((value)=>value).join('/'));
}
function getLegendKeysTitle(label) {
    return Object.keys(label).join('/');
}
function isSingleTrace(dt) {
    if (!dt) {
        return null;
    }
    // first two cols are domains (commit position / date)
    return dt.getNumberOfColumns() === 3;
}
function findTraceByLabel(dt, legendTraceId) {
    if (!dt) {
        return null;
    }
    const numCols = dt.getNumberOfColumns();
    // skip the first two columns since they are domains (commit position / date)
    for(let i = 2; i < numCols; i++){
        const label = dt.getColumnLabel(i);
        if (legendTraceId === label) {
            return label;
        }
    }
    return null;
}
function findTracesForParam(dt, paramKey, paramValues) {
    if (!dt) {
        return null;
    }
    // A matching trace will contain the key value pair in the form 'key=value'
    const expectedLabels = [];
    paramValues.forEach((paramValue)=>{
        const expectedLabelContent = ',' + paramKey + '=' + paramValue + ',';
        expectedLabels.push(expectedLabelContent);
    });
    const numCols = dt.getNumberOfColumns();
    const traces = [];
    // skip the first two columns since they are domains (commit position / date)
    for(let i = 2; i < numCols; i++){
        const label = dt.getColumnLabel(i);
        expectedLabels.forEach((expectedLabelContent)=>{
            if (label.includes(expectedLabelContent)) {
                traces.push(label);
            }
        });
    }
    return traces;
}
